module.exports = __webpack_public_path__ + "static/media/schedule_white_24dp.44567be2.svg";